const FORMAT = {
  JSON: {
    date: 'YYYY-MM-DD',
    time: 'HH:mm:ss',
  },
  DISPLAY: {
    date: 'MM-DD-YYYY',
    time: 'HH:mm:ss',
  },
  KEY: {
    date: 'YYYYMMDD',
    time: 'HHmmss',
  },
};

/** DateTime config. */
const datetimeConfig = {
  /** Format. */
  format: {
    /** JSON. */
    json: {
      ...FORMAT.JSON,
      datetime: `${FORMAT.JSON.date}[T]${FORMAT.JSON.time}[Z]`,
    },

    /** Display. */
    display: {
      ...FORMAT.DISPLAY,
      datetime: `${FORMAT.DISPLAY.date} ${FORMAT.DISPLAY.time}`,
    },

    /** Key. */
    key: {
      ...FORMAT.KEY,
      datetime: `${FORMAT.KEY.date}${FORMAT.KEY.time}`,
    },
  },
} as const;

export default datetimeConfig;
